import { CommonServiceContext } from "../../../services/common/commonService";
import { useContext, useEffect, useState } from "react";
import Loader from "../../../components/Loader";
import ReactDataTable from "react-data-table-component";
import { useParams } from "react-router-dom";
import {
  IconUser,
  IconPackage,
  IconInfoCircle,
  IconFiles,
  IconUpload,
  IconCash,
} from "@tabler/icons-react";
import { useUserContext } from "../../../context/user_context";
import { useNavigate } from "react-router-dom";
import RecaptchaComponent from "../../../components/RecaptchaComponent";

const CustomableShipment = () => {
  const { loading, searchParcel, parcel, downloadParcelInvoice, createPaymentOrder } = useContext(CommonServiceContext);
  const { captchaState, setCaptchaState } = useUserContext();
  const [parcelData, setParcelData] = useState({});
  const [parcelNumber, setParcelNumber] = useState("");
  //const [recaptchaCode, setRecaptchaCode] = useState("");
  const [resetCaptcha, setResetCaptcha] = useState(false);
  //1456331634
  const params = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (params.id) {
      //navigate(`/shipment/${encodeURIComponent(parcelNumber)}`);

      setParcelNumber(decodeURIComponent(params.id));
    }
  }, [params.id]);

  useEffect(() => {
    setCaptchaState({ ask: true, token: captchaState.token });
  }, []);

  // useEffect(() => {
  //   fetchParcel();
  // }, []);

  useEffect(() => {
    //fetchOrder();

    if (captchaState.token && !resetCaptcha) {

      fetchParcel();
    }
  }, [captchaState]);

  useEffect(() => {
    if (Object.keys(parcel).length > 0) {
      setParcelData(parcel);
      //console.log(parcel);
    }
  }, [parcel]);

  // useEffect(() => {
  //   console.log(parcelNumber);
  // }, [parcelNumber]);

  const fetchParcel = async () => {
    //setParcelData({});
    if (!parcelNumber) return;
    var recaptchaCode = captchaState.token;
    //temporary


    await searchParcel({ code: parcelNumber, recaptchaCode });
    setResetCaptcha(!resetCaptcha);
    setCaptchaState({ ask: false, token: null });
    navigate(`/shipment/${encodeURIComponent(parcelNumber)}`);
  };

  const handleSearchParcel = async () => {
    await fetchParcel();
  };

  const handleSearchSubmit = (e) => {
    if (!parcelNumber) return;

    if (process.env.NODE_ENV === "development") {
      //temporary
      fetchParcel();
      return;
    }


    e.preventDefault();

    navigate(`/shipment/${encodeURIComponent(parcelNumber)}`);
    window.location.reload();
  };

  const downloadInvoice = async (invoiceUrl) => {
    await downloadParcelInvoice(invoiceUrl);
  }

  const handleInvoiceDownload = (e, invoiceUrl) => {
    if (!invoiceUrl) return;
    e.preventDefault();
    downloadInvoice(invoiceUrl);
  };


  const handlePayButton = async (e, paymentUrl) => {
    var a = await createPaymentOrder(paymentUrl);
  }


  const columns = [
    {
      name: "გზავნილის ნომერი",
      selector: (row) => row.airwayBillNumber,
      cell: (row) => row.airwayBillNumber,
    },
    {
      name: "გამგზავნი",
      selector: (row) => row.shipperName,
      cell: (row) => row.shipperName,
    },
    // {
    //   name: "მიმღები",
    //   selector: (row) => row.consigneeName,
    //   cell: (row) => row.consigneeName,
    // },
    // {
    //   name: "მისამართი",
    //   selector: (row) => row.consigneeAddressLine1,
    //   cell: (row) => row.consigneeAddressLine1,
    // },
    {
      name: "ქალაქი",
      selector: (row) => row.consigneeAddressLine3,
      cell: (row) => row.consigneeAddressLine3,
    },
    {
      name: "შენახვის თანხა",
      selector: (row) => row.pkserviceFee,
      cell: (row) => row.pkserviceFee,
    },
    {
      name: "არასაკურიერო",
      selector: (row) => row.asServiceFee,
      cell: (row) => row.asServiceFee,
    },
  ];

  return (
    <>
      {loading && <Loader />}
      <div className="container">
        <section id="shipment" className="py-10 lg:py-20 mt-80">
          <div className="grid grid-cols-1 gap-6 md:grid-cols-1 2xl:grid-cols-1">
            <div className="mx-auto mb-12 max-w-xl text-center">
              <span className="rounded-md border border-primary bg-primary/20 px-3 py-1 text-xs font-medium uppercase tracking-wider text-primary">
                განსაბაჟებელი ნივთი
              </span>
            </div>
          </div>
          <div className="card bg-card-color rounded-xl">
            <div>
              <div className="form-control flex">
                <input
                  type="text"
                  className="form-input !rounded-e-none"
                  placeholder="ძიება..."
                  onChange={(e) => setParcelNumber(e.target.value)}
                  value={parcelNumber}
                />
                <button
                  className="btn btn-primary !rounded-s-none"
                  type="button"
                  onClick={(e) => handleSearchSubmit(e)}
                >
                  ძებნა
                </button>
              </div>
            </div>
          </div>
          {/* <div className="flex items-center text-bold text-[30px]/[32px] justify-center w-full mt-20">
                გზავნილი ვერ მოიძებნა
              </div> */}
          {captchaState.ask ? (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div
                  id="captcha"
                  style={{
                    display: captchaState.ask ? "block" : "none",
                  }}
                >
                  <RecaptchaComponent reset={resetCaptcha} />
                </div>
              </div>
            </>
          ) : (
            <>
              {parcelData.code == -1 ? (
                <>
                  <div className="flex items-center text-bold text-[30px]/[32px] justify-center w-full mt-20">
                    გზავნილი ვერ მოიძებნა
                  </div>
                </>
              ) : (
                <>
                  <div className="flex items-center justify-center w-full mt-20">
                    <div className="bg-card-color rounded-xl sm:p-4 p-2 max-w-[90vw] w-full shadow-shadow-sm border border-dashed border-border-color">
                      <div className="h-auto sm:p-4 p-3 ">
                        <div className="flex flex-wrap gap-4">
                          <div className="card bg-card-color rounded-xl p-4 relative border border-dashed border-border-color w-full sm:w-[calc(50%-0.75rem)] md:w-[calc(33.333%-0.75rem)]">
                            <IconPackage className="w-[36px] h-[36px] text-chart-color3" />
                            <h5 className="my-2 text-[20px]/[26px] font-medium">
                              ინფორმაცია დეკლარაციაზე
                            </h5>
                            <div className="flex gap-1 flex-wrap">
                              <span className="min-w-fit">ნომერი :</span>
                              <strong className="min-w-fit">
                                {parcelData?.declaration?.declarationNumber}
                              </strong>
                            </div>
                            <div className="flex gap-1 flex-wrap items-center">
                              <span className="min-w-fit">დეკლარაცია :</span>
                              <strong className="min-w-fit text-sm">
                                {parcelData?.declaration?.declarationFee}
                              </strong>
                            </div>
                            <div className="flex gap-1 flex-wrap items-center">
                              <span className="min-w-fit">სხვა სერვისები :</span>
                              <strong className="min-w-fit text-sm">
                                {parcelData?.declaration?.otherSerServiceFees}
                              </strong>
                            </div>
                            <div className="flex gap-1 flex-wrap items-center text-primary">
                              <strong className="min-w-fit">ჯამური თანხა :</strong>
                              <strong className="min-w-fit text-sm">
                                {parcelData?.declaration?.paymentSum}
                              </strong>
                            </div>
                            <div className="flex gap-1 flex-wrap">
                              <span className="min-w-fit">სტატუსი :</span>
                              <strong 
                              className={parcelData?.declaration?.isPayed?
                              "min-w-fit text-success":
                              "min-w-fit text-secondary"}>
                                {parcelData?.declaration?.paymentStatusName}
                              </strong>
                            </div>
                            <div className="flex gap-1 flex-wrap">
                              <span className="min-w-fit">ხელმოწერა :</span>
                              <strong className={parcelData?.declaration?.isSigned
                                ?"min-w-fit text-success":
                                "min-w-fit text-secondary"}>
                                {parcelData?.declaration?.signatureStatusName}
                              </strong>
                            </div>                             
                            {
                              false &&
                              (<div className="flex gap-1 flex-wrap">
                                <span className="min-w-fit">ინვოისი:</span>
                                {parcelData?.declaration?.invoiceUrl && (
                                  <a
                                    href="#"
                                    onClick={(e) => handleInvoiceDownload(e, parcelData?.declaration?.invoiceUrl)}
                                    target="_blank"
                                    rel="noreferrer"
                                  >
                                    <strong>ნახვა 🧾</strong>
                                  </a>
                                )}
                              </div>)
                            }
                          </div>
                          <div style={{ display: 'none' }} className="card bg-card-color rounded-xl p-4 relative border border-dashed border-border-color w-full sm:w-[calc(50%-0.75rem)] md:w-[calc(33.333%-0.75rem)]">
                            <IconUpload className="w-[36px] h-[36px] text-chart-color3" />
                            <div className="form-control">
                              <label className="form-label">
                                <span className="label-text">ფაილები:</span>
                              </label>
                              <input type="file" className="form-input" />
                            </div>
                          </div>
                          {
                            parcelData?.declaration?.isPayed != true &&
                            (<div className="bg-card-color rounded-xl p-4 border border-dashed border-border-color w-full sm:w-[calc(50%-0.75rem)] md:w-[calc(33.333%-0.75rem)]">
                              <IconCash className="w-[36px] h-[36px] text-chart-color3" />
                              <div className="form-control flex flex-col">
                                <label className="form-label">
                                  <span className="label-text">
                                    გადახდის მეთოდი :&nbsp;&nbsp;
                                  </span>
                                </label>
                                <label className=" cursor-pointer">
                                  <input
                                    type="radio"
                                    name="paymentMethod"
                                    className="form-radio"
                                    defaultChecked
                                    value="ბარათი"
                                  />
                                  <span className="ml-2">ბარათი</span>
                                </label>
                                <label className=" cursor-pointer " style={{ display: 'none' }}>
                                  <input
                                    type="radio"
                                    name="paymentMethod"
                                    className="form-radio"
                                    value="ინვოისი"
                                  />
                                  <span className="ml-2">ინვოისი</span>
                                </label>
                                <label className=" cursor-pointer" style={{ display: 'none' }}>
                                  <input
                                    type="radio"
                                    name="paymentMethod"
                                    className="form-radio"
                                    value="ქეში"
                                  />
                                  <span className="ml-2">ქეში</span>
                                </label>
                              </div>

                              <button
                                className="btn btn-primary mt-4 w-full sm:w-auto"
                                type="button"
                                onClick={(e) => handlePayButton(e, parcelData?.paymentRedirectionUrl)}
                              >
                                ონლაინ გადახდა
                              </button>
                            </div>)
                          }
                        </div>

                        <div className="react-data-table">
                          <ReactDataTable
                            columns={columns}
                            data={parcelData?.airWayBills}
                            enableFilters={false}
                            noDataComponent={
                              <div
                                style={{
                                  textAlign: "center",
                                  padding: "20px",
                                  color: "gray",
                                }}
                              >
                                გზავნილები არ გაქვთ
                              </div>
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </>
          )}
          {parcel ? (
            <>{Object.keys(parcelData).length == 0 ? <></> : <></>}</>
          ) : (
            <>
              {/* sm:max-h-[calc(100svh-48px-32px)] max-h-[calc(100svh-48px-16px)] */}
            </>
          )}
        </section>
      </div>
    </>
  );
};

export default CustomableShipment;
